import { clsx } from 'clsx';
import React, { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Span } from 'atoms/Typography';
import { VariantItem } from 'atoms/VariantLink';
import { useFilters } from 'organisms/Filters/hooks';
import { Facets, IFilter } from 'commerce/factFinder/types';
import { IChips } from '../types';
import styles from './styles.module.css';

interface ChipsProps extends IChips {
  isVisible?: boolean;
}

const ColorChip: FC<{ item: IFilter }> = ({ item }) => {
  const { filters, addMultipleFilter } = useFilters();
  const isSelected = filters?.find((a) => a.value === item.value);

  const value = item.value as string[];

  const colors = value.map((el) => ({
    value: el,
    label: el,
  }));

  return (
    <VariantItem
      isActive={!!isSelected}
      colors={colors}
      onClick={() => addMultipleFilter?.({ ...item, value: value.join('|') })}
    />
  );
};

const Chip: FC<{ item: IFilter }> = ({ item }) => {
  const { filters, addMultipleFilter } = useFilters();
  const isSelected = filters?.find((a) => a.value === item.value);

  return (
    <Span
      key={item.displayValue}
      className={clsx(styles.item, isSelected && styles.active)}
      onClick={() => addMultipleFilter?.(item)}
    >
      <Span className={styles.text}>{item.displayValue}</Span>
      {isSelected && <Icon className={styles.icon} type={IconType.close} />}
    </Span>
  );
};

export const Chips: FC<ChipsProps> = ({ list, isVisible }) => {
  const { chipsState } = useFilters();
  const chipsList = list || chipsState?.list;
  const isColorChips = chipsList?.some((item) => item.type === Facets.COLORS);

  return !chipsList?.length || !isVisible ? null : (
    <div className={clsx(styles.list, !isColorChips && styles.container)}>
      {chipsList?.map((item) =>
        isColorChips ? (
          <ColorChip key={item.displayValue} item={item} />
        ) : (
          <Chip key={item.displayValue} item={item} />
        ),
      )}
    </div>
  );
};

export const ResultChips: FC<IChips> = ({ list }) => {
  const { chipsState } = useFilters();
  const chipsList = list || chipsState?.list;

  return !chipsList?.length ? null : (
    <div className={styles.list}>
      {chipsList?.map((item) => <Chip key={item.displayValue} item={item} />)}
    </div>
  );
};
